import React from 'react'
import {Box, BoxProps, Flex} from '../../vanilla'
import {progressCircleArc, progressCircleBase} from './progress-circle-icon.css'

interface ProgressCircleIconProps extends BoxProps<'svg'> {
  progress: number
  total: number
}

export const ProgressCircleIcon = ({progress, total, ...props}: ProgressCircleIconProps) => {
  const progressRatio = progress / total
  let strokeDasharray = ''

  const renderProgress = progressRatio > 0 && progressRatio <= 1
  const complete = progressRatio >= 1

  // Calculate stroke array to draw arc based on progress if we need to render it
  if (renderProgress) {
    const CIRCLE_RADIUS = 15
    const CIRCLE_CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS

    let drawArcLength = progressRatio * 2 * Math.PI * CIRCLE_RADIUS
    if (drawArcLength === 0) drawArcLength = 100
    strokeDasharray = `${drawArcLength} ${CIRCLE_CIRCUMFERENCE * 2}`
  }

  const strokeColor = complete ? '#02B122' : '#CC092F'

  const textStyle = {
    fill: '#000',
    leadingTrim: 'both',
    textEdge: 'cap',
    fontFamily: '"Instrument Sans", Arial, sans-serif',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal'
  }

  return (
    <Flex position='relative'>
      <Box position='absolute' style={{'top':`50%`,'left':'50%','transform':'translate(-50%, -50%)'}} >
        {!complete && (
          <text style={textStyle}>
            {progress}
            <tspan fill="#979797">/</tspan>
            {total}
          </text>
        )}
        </Box>
      <Box as="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" fill="white" {...props}>
        <circle
          cx="20"
          cy="20"
          r="15"
          stroke="white"
          strokeWidth="3"
          className={progressCircleBase}
        />
        {renderProgress && (
          <circle
            cx="20"
            cy="20"
            r="15"
            stroke={strokeColor}
            transform="rotate(-90 20 20)"
            strokeWidth="3"
            strokeDasharray={strokeDasharray}
            className={progressCircleArc}
          />
        )}
        {complete && (
          <path
            transform="translate(14, 15)"
            d="M4 9.4L0 5.4L1.4 4L4 6.6L10.6 0L12 1.4L4 9.4Z"
            fill="#1C1B1F"
          />
        )}
      </Box>
    </Flex>
  )
}
